import { default as folderValidationSchema } from '@/components/dialogs/AddFolderSharepointDialog/validationSchema';
import * as Yup from 'yup';
import {
	CLIENT_ID,
	DEAL_NAME,
	FILES,
	YEAR_FOLDER,
} from '../CreateNewBusinessForm/validationSchema';

export const validationSchema = Yup.object()
	.shape({
		[CLIENT_ID]: Yup.string().required('Client is required.'),
		// [DEAL_NAME]: Yup.string().required('Deal name is required.'),
		[FILES]: Yup.array(),
		notes: Yup.string(),
		priority: Yup.string().nullable(true),
		[YEAR_FOLDER]: Yup.string().required('Year folder is required.'),
		policies: Yup.array().min(1, 'At least one policy is required').ensure(),
		policyId: Yup.number().nullable(true),
		// policyTransactionId: Yup.number().nullable(false).required('Please select a policy Transaction'),
		// policyId: Yup.number().required('Please select a policy').min(0, 'Please select a policy'),
	})
	.concat(folderValidationSchema([], 'Deal name'));
// .test('either-policyId-or-policies', 'Please select a policy.', function (value) {
// 	if (!value) return false;

// 	const { policyId, policies } = value;

// 	const hasPolicyId = typeof policyId === 'number' && policyId >= 0;
// 	const hasPolicies = Array.isArray(policies) && policies.length > 0;

// 	return hasPolicyId || hasPolicies;
// });
